export const enum UserProviderType {
    UsernamePassword = 'UsernamePassword',
    Google = 'Google',
    Facebook = 'Facebook',
}
